import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { MODULE_NAME as TRACKING_MODULE } from 'modules/tracking/config/routes';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { FUNNELS_REPORT_ID } from './funnelsReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const unipFunnelsTrackingReportConfig = {
    id: FUNNELS_REPORT_ID,
    label: 'Conversion Funnels',
    permissions: ['TA_CONVERSION_FUNNEL'],
    accountConfigurations: {
        [FEATURE_FLAGS.CONVERSION_FUNNEL_ENABLED]: 'true',
    },
    module: TRACKING_MODULE,
    endpoint: 'funnels',
    rowIdField: FIELDS.FUNNEL_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    searchPlaceholderMsgId: 'tracking.funnels.report.search.placeholder',
    searchField: FIELDS.FUNNEL_NAME.field,
    filters: [],
    initialFilters: [],
};
